import React from 'react';

import { withStyles, WithStyles } from '@material-ui/core';

import { Button, ButtonProps } from 'components/v2';

import styles from './CancelButtonContainer.styles';

export interface CancelButtonContainerProps extends Omit<ButtonProps, 'classes'>, WithStyles<typeof styles> {}

const CancelButtonContainer: React.FC<CancelButtonContainerProps> = (props) => {
  const { children, classes, ...rest } = props;

  return (
    <Button
      className={classes.actionButton}
      color="primary"
      data-lh-id="lumabot-cancel-button"
      extraPadding
      extraRounded
      fullWidth
      variant="contained"
      {...rest}
    >
      {children}
    </Button>
  );
};

export default withStyles(styles, { name: 'CancelButtonContainer' })(CancelButtonContainer);
